module.exports = __webpack_public_path__ + "static/img/7.90cb441.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/7.png
// module id = Jnvn
// module chunks = 0